<!-- =========================================================================================
  File Name: NewQuoteSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ !this.data.carrierToEdit ? "Adicionar" : "Editar" }} Transportadora</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
      <div class="p-6">
        <h6 class="mb-2">Nome Curto</h6>
        <vs-input name="nomeCurto" v-validate="'required'" class="w-full" v-model="newCarrier.nomeCurto"></vs-input>
        <span class="text-danger text-sm mb-3 inline-block" v-show="errors.has('nomeCurto')">{{ errors.first('nomeCurto') }}</span>
        <br>
        <h6 class="mb-2">Razão Social</h6>
        <vs-input name="razaoSocial" v-validate="'required'" class="w-full" v-model="newCarrier.razaoSocial"></vs-input>
        <span class="text-danger text-sm mb-3 inline-block" v-show="errors.has('razaoSocial')">{{ errors.first('razaoSocial') }}</span>
        <br>
        <h6 class="mb-2">CPF/CNPJ</h6>
        <vs-input name="cpfCnpj" v-validate="'required'" class="w-full" v-model="newCarrier.cpfCnpj"></vs-input>
        <span class="text-danger text-sm mb-3 inline-block" v-show="errors.has('cpfCnpj')">{{ errors.first('cpfCnpj') }}</span>
        <br>
        <h6 class="mb-2">Telefone</h6>
        <vs-input name="telefone" v-validate="'required'" class="w-full" v-model="newCarrier.telefone"></vs-input>
        <br>
        <h6 class="mb-2">CEP</h6>
        <vs-input name="cep" v-validate="'required'" class="w-full" v-model="newCarrier.cep"></vs-input>
        <span class="text-danger text-sm mb-3 inline-block" v-show="errors.has('cep')">{{ errors.first('cep') }}</span>
        <br>
        <h6 class="mb-2">Endereço</h6>
        <vs-input name="endereco" v-validate="'required'" class="w-full" v-model="newCarrier.endereco"></vs-input>
        <span class="text-danger text-sm mb-3 inline-block" v-show="errors.has('endereco')">{{ errors.first('endereco') }}</span>
        <br>
        <h6 class="mb-2">Número</h6>
        <vs-input name="numeroCasa" class="w-full" v-model="newCarrier.numeroCasa"></vs-input>
        <br>
        <h6 class="mb-2">Bairro</h6>
        <vs-input name="bairro" v-validate="'required'" class="w-full" v-model="newCarrier.bairro"></vs-input>
        <span class="text-danger text-sm mb-3 inline-block" v-show="errors.has('bairro')">{{ errors.first('bairro') }}</span>
        <br>
        <h6 class="mb-2">Município</h6>
        <vs-input name="cidade" v-validate="'required'" class="w-full" v-model="newCarrier.cidade"></vs-input>
        <span class="text-danger text-sm mb-3 inline-block" v-show="errors.has('cidade')">{{ errors.first('cidade') }}</span>
        <br>
        <h6 class="mb-2">Estado (Sigla)</h6>
        <vs-input name="estado" v-validate="'required'" class="w-full" v-model="newCarrier.estado"></vs-input>
        <span class="text-danger text-sm mb-3 inline-block" v-show="errors.has('estado')">{{ errors.first('estado') }}</span>
      </div>
    </VuePerfectScrollbar>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData('add')" v-if="!this.data.carrierToEdit">Salvar</vs-button>
      <vs-button class="mr-6" @click="submitData('edit')" v-else-if="this.data.carrierToEdit">Editar</vs-button>
      <vs-button type="border" color="danger" @click="closeSidebar()">Cancelar</vs-button>
    </div>
  </vs-sidebar>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import helpers from "@/helpers";
import { Validator } from 'vee-validate';

const dict = {
  custom: {
    nomeCurto: { required: 'Insira o nome curto (Ex: Correios)' },
    razaoSocial: { required: 'Insira a razão social' },
    cpfCnpj: { required: 'Insira o CPF/CNPJ' },
    cep: { required: 'Insira o CEP' },
    endereco: { required: 'Insira o endereço' },
    bairro: { required: 'Insira o bairro' },
    cidade: { required: 'Insira o município' },
    estado: { required: 'Insira o estado' },
  }
};

Validator.localize('en', dict);
export default {
  components: {
    VuePerfectScrollbar,
  },
  directives: helpers.directives,
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => []
    }
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      this.$validator.reset();
      if (!this.data.carrierToEdit) {
        this.initValues();
      } else {
        this.newCarrier = _.cloneDeep(this.data.carrierToEdit)
      }
    }
  },
  data() {
    return {
      newCarrier: {},
      helpers: null,
      settings: {
        wheelSpeed: 0.2
      },
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    },
  },
  methods: {
    closeSidebar() {
      this.initValues()
      this.$emit("closeSidebar");
    },
    initValues() {
      this.newCarrier = {}
      this.data.carrierToEdit = null
      this.helpers = helpers
    },
    async submitData(option) {
      const haveErrors = !(await this.$validator.validateAll())
      if (haveErrors)
        return
      const payload = {
        notify: this.$vs.notify,
        formData: this.newCarrier,
      }

      if (option == 'add') {
        await this.$store.dispatch("addCarrier", payload)
      } else if (option == 'edit') {
        payload.idTransportadora = this.newCarrier.idTransportadora
        await this.$store.dispatch("updateCarrier", payload)
      }
      this.$emit("closeSidebar");
      this.initValues();
    },
  },
};

</script>
<style
  lang="scss"
  scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

</style>
